import API from '../index';
import { Order } from '../../types/common';

const rejectAdjustment = async (orderId: string, shipmentId: string): Promise<Order> => {
  const data: Order = await API.post(`/orders/${orderId}/confirm-adjustment`, {
    shipmentRef: shipmentId,
    confirm: false,
  });
  return data;
};

export default rejectAdjustment;
